import BreadCrumbs from '@components/breadcrumbs/Breadcrumbs'
import mix from '@utils/styles/mix'

import styles from '@components/blog/styles/PageContainer.module.css'

function PostContainer ({ children }) {
    return (
        <section>
            <section className={mix([styles.crumbs, 'container'])} style={{ margin: '20px 0' }}>
                <BreadCrumbs skip={['kategoria', 'tagi', 'wpis']} />
            </section>

            <article>
                { children }
            </article>
            <br/><br/>
        </section>
    )
}

export default PostContainer